'use strict';

const get = require('lodash/get');

const NEARBY_DEALS_TO_SHOW_WHEN_PLACE_HAS_NO_DEALS = 3;

const NearbyDeals = require('./nearby_deals');

module.exports = (function() {
  class PlacePreviewDrawer {
    static initClass() {
      this.prototype.onCloseCallbacks = null;
      this.prototype.templates = {
        main: require('../main.html.mustache'),
        oneDeal: require('../one_deal.html.mustache'),
        dealCard: require('../../deals/deal_card.html.mustache'),
        couponCard: require('../../coupons/coupon_card.html.mustache'),
        address: {
          US: require('../../merchant_information/address_templates/address_US.html.mustache'),
          DE: require('../../merchant_information/address_templates/address_DE.html.mustache'),
          ES: require('../../merchant_information/address_templates/address_ES.html.mustache'),
          FR: require('../../merchant_information/address_templates/address_FR.html.mustache'),
          GB: require('../../merchant_information/address_templates/address_GB.html.mustache'),
          IT: require('../../merchant_information/address_templates/address_IT.html.mustache'),
        },
      };
    }

    constructor({ place, $el }) {
      this.place = place;
      this.$el = $el;
      this.id = Math.floor(Math.random() * (9999 - 1000)) + 1000;
      this.onCloseCallbacks = [];
      this.render();
    }

    render() {
      const template = this.shouldUseOneDealTemplate()
        ? this.templates.oneDeal
        : this.templates.main;
      const html = template.render(this.placeTemplateData());
      this.$el.html(html);
      GIG.Utils.truncateElements(this.$el);
      this.$el.removeClass('hidden');
      this.$el.find('.icon-x').click(() => this.hide());
      this.$el.find('.mpp-coupon-card').click(evt => {
        const couponId = $(evt.currentTarget).data('id');
        return window.open(`/biz/${this.place.slug}?coupon_id=${couponId}`);
      });

      const $nearbyDeals = this.$el.find('.place-preview-nearby-deals');

      if ($nearbyDeals.length > 0) {
        new NearbyDeals({
          $el: $nearbyDeals,
          place: this.place,
          limit: NEARBY_DEALS_TO_SHOW_WHEN_PLACE_HAS_NO_DEALS,
        });
      }

      return this.$el;
    }

    hasOffers() {
      return this.hasDeals() || this.hasCoupons();
    }

    hasDeals() {
      return get(this.place, 'offers.deal.items', []).length > 0;
    }

    hasCoupons() {
      return get(this.place, 'offers.coupon.items', []).length > 0;
    }

    shouldUseOneDealTemplate() {
      return (
        this.place.offers != null &&
        get(this.place, 'offers.deal.items', []).length === 1 &&
        !this.hasCoupons()
      );
    }

    addressHtml() {
      const data = this.place.location;
      const template =
        this.templates.address[I18n.country] != null
          ? this.templates.address[I18n.country]
          : this.templates.address['US'];
      return template.render(data);
    }

    couponsHtml() {
      const coupons = get(this.place, 'offers.coupon.items', undefined);

      if (!((coupons != null ? coupons.length : undefined) > 0)) {
        return null;
      }

      let couponsHtml = '';

      for (const coupon of coupons) {
        coupon.translate = coupon.t = () => str => I18n.t(str);

        couponsHtml += this.templates.couponCard.render(coupon);
      }

      return couponsHtml;
    }

    dealsHtml() {
      const deals = get(this.place, 'offers.deal.items', undefined);

      if (!((deals != null ? deals.length : undefined) > 0)) {
        return null;
      }

      let dealsHtml = '';

      for (const deal of deals) {
        deal.forceMobileStyles = true;

        deal.translate = deal.t = () => str => I18n.t(str);

        dealsHtml += this.templates.dealCard.render(deal);
      }

      return dealsHtml;
    }

    oneDealData() {
      const deal = get(this.place, 'offers.deal.items[0]', undefined);

      if (deal == null) {
        return null;
      }

      return _.extend(deal, {
        headerImage:
          deal.sidebarImageUrl != null
            ? deal.sidebarImageUrl.replace(
                /\/[tc][0-9]+x[0-9]+\./,
                '/t600x320.'
              )
            : undefined,
      });
    }

    getViewPageButtonTranslation() {
      if (this.shouldUseOneDealTemplate()) {
        return I18n.t('js.modules.offers_map_preview_drawer.view_deal');
      }

      let offerCount = 0;

      if (get(this.place, 'offers.deal.total', undefined) > 0) {
        offerCount += this.place.offers.deal.total;
      }

      if (get(this.place, 'offers.coupon.total', undefined) > 0) {
        offerCount += this.place.offers.coupon.total;
      }

      if (offerCount > 10) {
        return I18n.t(
          'js.modules.offers_map_preview_drawer.view_all_x_offers',
          {
            count: offerCount,
          }
        );
      } else {
        return I18n.t('js.modules.offers_map_preview_drawer.view_page');
      }
    }

    placeTemplateData() {
      const data = {};

      data.translate = data.t = () => str => I18n.t(str);

      return _.extend(data, this.place, {
        noOffers: !this.hasOffers(),
        deal: this.oneDealData(),
        addressHtml: this.addressHtml(),
        dealsHtml: this.dealsHtml(),
        couponsHtml: this.couponsHtml(),
        translations: {
          notRunningDeal: I18n.t(
            'js.modules.offers_map_preview_drawer.not_running_any_deal',
            {
              merchantName: this.place.name,
            }
          ),
          viewPageButton: this.getViewPageButtonTranslation(),
        },
      });
    }

    isVisible() {
      return this.$el.hasClass('hidden') === false;
    }

    hide(data) {
      this.$el.addClass('hidden');
      return this.triggerClose(data);
    }

    triggerClose(data) {
      for (const cb of this.onCloseCallbacks) {
        cb(data);
      }

      this.onCloseCallbacks = [];
      return this.onCloseCallbacks;
    }

    onceOnClose(cb) {
      this.onCloseCallbacks.push(cb);
    }
  }
  PlacePreviewDrawer.initClass();
  return PlacePreviewDrawer;
})();
